import React, { useState, useEffect } from "react";
import Countdown from "components/Countdown";
import Disclaimer from "components/Disclaimer";

import DownloadForm from "components/DownloadForm";
import QRCode from "components/QRCode";

import { CLAIM_STATES } from "../libs/state";

const Header = (props) => {
  const [currentClaimState, setCurrentClaimState] = useState(props.claimState);

  const [isDownloadFormVisible, setIsDownloadFormVisible] = useState(false);
  const [isQRVisible, setIsQRVisible] = useState(false);

  const [npRegisteredEmail, setNpRegisteredEmail] = useState(false);

  useEffect(() => {
    if (props.claimState !== currentClaimState) {
      setCurrentClaimState(props.claimState);
    }
  }, [props.claimState]);

  const handleDownloadFormSuccess = (registeredEmail) => {
    setNpRegisteredEmail(registeredEmail);
    setIsDownloadFormVisible(false);
    setCurrentClaimState(CLAIM_STATES[7]);
  };

  return (
    <>
      <header className="header">
        {(() => {
          switch (currentClaimState) {
            case CLAIM_STATES[3]:
              return (
                <>
                  <h1 className="header__title" data-end={true}>
                    All set!
                  </h1>
                  <h2 className="header__subtitle">
                    Your collectible is ready for you
                  </h2>
                  <a
                    href={props.currentArtist["link"]}
                    className="header__button button">
                    Open the Sweet App to claim it
                  </a>
                </>
              );
            case CLAIM_STATES[4]:
              return (
                <>
                  <h1 className="header__title" data-end={true}>
                    Oh no!
                  </h1>
                  <h2 className="header__subtitle">
                    It looks like you didn't scan a meal box QR code
                  </h2>
                  <a
                    href="https://www.bk.com/menu/section-55c683a3-ba01-4796-9452-3826b0ef74d3"
                    target="_blank"
                    rel="noreferrer"
                    className="header__button button">
                    Get your Meal Box at your Local Burger King <small>*</small>
                  </a>
                  <Disclaimer
                    hasAsterisk={true}
                    currentUrl={props.currentUrl}
                    onRulesClick={() => props.onRulesClick()}
                  />
                </>
              );
            case CLAIM_STATES[5]:
              return (
                <>
                  <h1 className="header__title" data-end={true}>
                    All set!
                  </h1>
                  <h2 className="header__subtitle">
                    Your collectible is ready for you
                  </h2>
                  <a
                    href={props.currentArtist["link"]}
                    className="header__button button">
                    Open the Sweet App to claim it
                  </a>

                  <p className="disclaimer" data-size="lg">
                    On a desktop device?{" "}
                    <a onClick={() => setIsQRVisible(true)}>Click here</a> to
                    scan the QR code with your mobile phone.<br />Don't have a mobile
                    phone?{" "}
                    <a onClick={() => setIsDownloadFormVisible(true)}>
                      Complete this form
                    </a>{" "}
                    for further instructions.
                  </p>
                </>
              );
            case CLAIM_STATES[6]:
              return (
                <>
                  <h1 className="header__title" data-end={true}>
                  Ooops!
                  </h1>
                  <h2 className="header__subtitle">
                  It seems like you missed it.
                  <br />
                  <br />
                  Our Keep it Real Meals NFT game has ended.
                  </h2>

                  {/* <Countdown date={props.dropDate} /> */}
                </>
              );
            case CLAIM_STATES[7]:
              return (
                <>
                  <h1 className="header__title" data-end={true}>
                    Thanks!
                  </h1>
                  <h2 className="header__subtitle">
                    Please register for your wallet account at Sweet.io.
                    <br />
                  </h2>
                  {npRegisteredEmail && (
                    <p className="header__text">
                      Be sure to register with{" "}
                      <span className="email">{npRegisteredEmail}</span> to
                      receive your game piece.
                    </p>
                  )}
                  <p className="header__text">It make take several hours before the game piece is available in your wallet.</p>
                  <a href="http://sweet.io/" className="header__button button">
                    Register now
                  </a>
                </>
              );
            default:
              return (
                <>
                  <h1 className="header__title">Congratulations!</h1>
                  <h2 className="header__subtitle">
                    You are about to collect your{" "}
                    <strong>Keep It Real Meals</strong> NFT game piece
                  </h2>
                </>
              );
          }
        })()}
        <span className="header__logo" alt="Burger King Sweepstakes" />
      </header>

      {isDownloadFormVisible && (
        <DownloadForm
          toggleDownload={() => setIsDownloadFormVisible(false)}
          recaptchaCode={props.recaptchaCode}
          onFormSuccess={handleDownloadFormSuccess}
          selectedArtist={props.currentArtist}
        />
      )}

      {isQRVisible && (
        <QRCode
          toggleQR={() => setIsQRVisible(false)}
          selectedArtist={props.currentArtist}
        />
      )}
    </>
  );
};

export default Header;
